export default {
  SUPPORT_INFO_LIST_REQUEST: 'APP/SUPPORT_INFO/SUPPORT_INFO_LIST_REQUEST',
  SUPPORT_INFO_LIST_SUCCESS: 'APP/SUPPORT_INFO/SUPPORT_INFO_LIST_SUCCESS',
  SUPPORT_INFO_LIST_ERROR: 'APP/SUPPORT_INFO/SUPPORT_INFO_LIST_ERROR',
};
